import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-section-grid',
  imports: [],
  templateUrl: './section-grid.component.html',
  styleUrl: './section-grid.component.scss'
})
export class SectionGridComponent {
    @Input() subSection: string = '';
}
